import TEMPLATE_URL from "emun.products/lists/product-list-quick-viewer.htm";
import controller from "emun.products/lists/product-list-quick-viewer.controller";
import open from "webmodals/open";

export default ({
  size = "sm",
  backdrop = true,
  templateUrl = TEMPLATE_URL,
  placement = "right",
  title = `Current Wishlist`,
  tab,
  retailerId,
  listId
} = {}) =>
  open({
    size,
    backdrop,
    placement,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      listId: () => listId,
      retailerId: () => retailerId,
      tab: () => tab,
      title: () => title
    }
  }).result;
